import React from "react";
import Navbar from "../navbar/Navbar";
import Footer from "./Footer";
import Hero from "../hero/Hero";
import Info from "./Info";
import Services from "./Services";
import Image from "./Image";

const MainPage = () => {
  return (
    <div className="grid-container ">
      <Navbar />
      <Hero className="is-small" fluid="is-fluid">
        <Image />
      </Hero>
      <div className="gd-blue">
        <Hero size="is-small" fluid="is-fluid">
          <Services />
        </Hero>
        <Hero size="is-small">
          <Info />
        </Hero>
        <Hero size="is-small" color="">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3127.0409987221665!2d27.00410861533563!3d38.39430107965142!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x495373aec4c047cb!2zRGnFnyBIZWtpbWkgQmF0dWhhbiBIxLFkxLFyb8SfbHU!5e0!3m2!1sen!2sus!4v1531879352599"
            width="100%"
            height="450"
            frameBorder="0"
            allowFullScreen
            title="Harita"
          />
        </Hero>
      </div>
      <Footer />
    </div>
  );
};

export default MainPage;



// WEBPACK FOOTER //
// ./src/components/main/MainPage.js